export const RECOMMENDED_CONTENT_CATEGORY = 'v65';
